module.exports = __webpack_public_path__ + "static/media/amazon-es-icon.00deeb85.svg";